<template>
  <div class="upSuccess">
    <img :src="require('@/assets/images/icon/001_05.jpg')" />
    <p class="success">{{flags[this.$route.query.flag]}}申请提交成功</p>
    <div class="routelink">
      <p>进入审核阶段的资料不可修改</p>
      <span class="time">{{time}}s</span>后自动跳转到机构列表
    </div>
    <el-button type="primary" @click="toList" class="mainBtn">返回机构列表</el-button>
  </div>
</template>

<script>
const flags = {
  new: "新设",
  update: "变更",
  add: "迁入"
};
export default {
  data() {
    return {
      flags,
      time: 5
    };
  },

  mounted() {
    this.countToLink();
  },

  methods: {
    toList() {
  
      const path = this.$route.path.split('/')[1]
      this.$router.push(`/${path}/FundList`);
    },

    countToLink() {
      let time = setInterval(() => {
        this.time--;
        if (this.time == 0) {
          clearInterval(time);
          this.toList();
        }
      }, 1000);
    }
  }
};
</script>

<style scoped>
.upSuccess {
  text-align: center;
  padding-top: 10%;
}
.success {
  font-size: 24px;
  color: #0f1824;
  margin: 16px 0px;
}

.routelink {
  font-family: MicrosoftYaHei;
  font-size: 16px;
  color: #967f7f;
  text-align: center;
  line-height: 21px;
  margin-bottom: 10px;
}

.time {
  color: #3165ff;
}
</style>

